module.exports = __webpack_public_path__ + "img/PAD.fbb3b122.svg";